export default "__VITE_ASSET__CopaVJqX__"